
<app-abandoned-reservation-header
  [user]="user"
  [translationType]="'HOTELS'">
</app-abandoned-reservation-header>
<app-abandoned-reservation-body [hasImage]="true">
  <app-image
    image
    [type]="typeImage"
    [src]="reservation?.Hotel?.Thumbnail"
    [maxHeight]="155"
    [borderRadius]="8"
    [borderRadiusOnlyTop]="true">
  </app-image>
  <ng-container content>
    <app-hotel-segment-detail
      [hotelReservation]="reservation"
      [isAdandonedHotelReservation]="true"
      [showRoomsDetail]="true">
    </app-hotel-segment-detail>
    <app-abandoned-reservation-actions
      [itineraryId]="itinerary?.Id"
      [reservationType]="reservationType"
      [userId]="user?.id"
      [isMobile]="isMobile"
      [isLoadingCancellation]="isLoadingCancellation"
      (cancelEvent)="cancelEvent.emit(reservation?.Id)">
    </app-abandoned-reservation-actions>
  </ng-container>
</app-abandoned-reservation-body>